module.exports = __webpack_public_path__ + "assets/img/arrow.69941f6a.svg";